export const UPDATE = '@@intl/UPDATE';

export type IntlState = {
  locale: string;
  messages: any;
  formats?: any;
};

export const updateIntl = ({ locale, formats, messages }: any) => ({
  type: UPDATE,
  payload: { locale, formats, messages },
});

export const initialState: IntlState = {
  locale: 'en',
  messages: { initEmpty: 'true' },
};

export function intlReducer(
  state: IntlState = initialState,
  action: any = {}
): IntlState {
  if (action.type !== UPDATE) {
    return state;
  }

  return { ...state, ...action.payload };
}
